module.exports = __webpack_public_path__ + "img/05.704f94da.png";